import ClayLoadingIndicator from "@clayui/loading-indicator";
import React from "react";
import {useTranslation} from "react-i18next";
import InsuranceCaseSelect from "./InsuranceCaseSelect";
import {InsuranceCartsContext} from "../util/Context";

export default function InsuranceSelect({
                                            insurances, insurancesLoading, insuranceId, setInsuranceId
                                        }) {
    const {t} = useTranslation();
    if (insurancesLoading) return <ClayLoadingIndicator/>;
    else if (insurances?.length === 0) return <></>
    return (
        <>
            <div className="form-group input-text-wrapper">
                <label className="control-label"
                       htmlFor="insurance-select">
                    {t('insurance')}
                </label>
                <select value={insuranceId} id="insurance-select" className={"form-control success-field"}
                        onChange={e => setInsuranceId(e.target.value)}>
                    <option disabled={"disabled"} value={0}>{t("insurance")}</option>
                    {insurances.map(insurance => (
                        <option key={insurance.id} value={insurance.id}>{insurance.name}</option>
                    ))}
                </select>
            </div>

            <InsuranceCaseSelect insuranceId={insuranceId}/>
        </>


    )
}